import React from 'react';
import {  Link } from "react-router-dom";
import Logo from './img/nature-hearing-aid-logo-png.png';

class Navbar extends React.Component{
  state = {
     isOpen:false,
     //linkActive
    }
    handleToggle = () => {
      this.setState({isOpen:!this.state.isOpen})
    }
  render() {
	return(
       <div>
 <nav className="navbar navbar-default navbar-trans navbar-expand-lg fixed-top">
    <div className="container-fluid">
      <div className="d-flex">
        <div className="p1">
      <a className="navbar-brand text-brand" href="/"><img src={Logo} alt="" className="mx-auto d-block img-fluid"/></a>
      </div>
      <div className="p1"> 
      <button onClick={this.handleToggle} 
      className={this.state.isOpen ? "navbar-toggler" : "navbar-toggler collapsed"} type="button" data-toggle="collapse" data-target="#navbarDefault"
        aria-controls="navbarDefault" aria-expanded="false" aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
      </button>
      </div>
      </div>
      <div className={this.state.isOpen ? "navbar-collapse collapse justify-content-end collapse show" : "navbar-collapse collapse justify-content-end"} id="navbarDefault">
        <ul className="navbar-nav">
          <li className="nav-item">
		   <Link  activeClassName='active'  onClick={this.handleToggle} className="nav-link" to="/">Home</Link>
             
          </li>
          <li className="nav-item">
		   <Link  activeClassName='active' onClick={this.handleToggle} className="nav-link" to="/About">About Us</Link>
           </li>        
           <li className="nav-item">
		   <Link  activeClassName='active' onClick={this.handleToggle} className="nav-link" to="/Gallery">Gallery</Link>
           </li>
          <li className="nav-item dropdown">
          <Link  activeClassName='active' onClick={this.handleToggle} className="nav-link" to="/Services" >Services</Link>
          </li>
          <li className="nav-item dropdown">
          <Link  activeClassName='active' onClick={this.handleToggle} className="nav-link" to="/Press-Release" >Press Release</Link>
          </li>
          <li className="nav-item">
          <Link  activeClassName='active' onClick={this.handleToggle} className="nav-link" to="/Contact">Contact</Link>            
          </li>
        </ul>
      </div>
      
    </div>
  </nav>
         
      </div>
 )
  }
	}
	
export default Navbar